import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { compose, wrapDisplayName } from 'recompose';

import { withFetch, withLoading } from 'modules/with-fetch';
import IMAGES from 'modules/assets/web';
import {
  isExistingOnboardingEntry,
  hasLegacyOnboardingData,
} from 'modules/functions/src/hasExistingOnboardingData';
import Loading from 'modules/loading';

import ActiveNavItem from './ActiveNavItem';

class ExistingEntryItems extends React.Component {
  static propTypes = {
    myQuestionnaire: PropTypes.object.isRequired,
    myTrainer: PropTypes.object.isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  // The user must both have completed onboarding (or legacy onboarding) AND have a trainer assigned.
  conditionallyDisplayEntryCompletedItems = () =>
    (isExistingOnboardingEntry(this.props.myQuestionnaire) ||
      hasLegacyOnboardingData(this.props.myQuestionnaire)) &&
    this.props.myTrainer.data &&
    this.props.myTrainer.data.length > 0;

  render() {
    return (
      <React.Fragment>
        {/* <ActiveNavItem path="myaccount">
          <Link className="nav-link text-white" to="/myaccount">
            <img alt="icon-profile" src={IMAGES.SIDEBAR_PROFILE} />
            Profile
          </Link>
        </ActiveNavItem>
        */}
        {this.conditionallyDisplayEntryCompletedItems() && (
          <ActiveNavItem path="messages">
            <Link
              className="nav-link text-white"
              to="/messages"
              onClick={this.props.onClick}
            >
              <img alt="icon-chat" src={IMAGES.SIDEBAR_CHAT} />
              Chat
            </Link>
          </ActiveNavItem>
        )}
      </React.Fragment>
    );
  }
}

const LoadingWithDiv = () => (
  <div>
    <Loading />
  </div>
);

const EnhancedComponent = compose(
  withFetch('Client/MyQuestionnaire', undefined, 'myQuestionnaire'),
  withFetch('Client/MyTrainer', undefined, 'myTrainer'),
  withLoading('myQuestionnaire', LoadingWithDiv),
  withLoading('myTrainer', LoadingWithDiv),
)(ExistingEntryItems);

EnhancedComponent.displayName = wrapDisplayName(
  ExistingEntryItems,
  'withFetch',
);

// This is needed otherwise router updates don't get passed to ActiveNavItem
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
export default withRouter(EnhancedComponent);
